import { type FC, type ReactNode } from 'react';

import { Dialog } from '@base-ui/react/dialog';
import { X } from 'lucide-react';

import { LegalProse } from '@shared/ui/LegalDocument';

import styles from './DocumentDialog.module.css';

interface DocumentDialogProps {
  /** Заголовок окна — название документа */
  title: string;
  /** Текст ссылки-кнопки, которая открывает окно */
  trigger: ReactNode;
  children: ReactNode;
}

/**
 * Документ поверх страницы: прочитал, закрыл — и вернулся к форме, не теряя введённое.
 * Base UI держит фокус внутри окна, закрывает по Esc и клику по фону, возвращает фокус на ссылку
 */
export const DocumentDialog: FC<DocumentDialogProps> = ({ title, trigger, children }) => (
  <Dialog.Root>
    {/* span, а не button: кнопка — неразрывная коробка и в узкой строке уезжает целиком на новую
        строку. preventDefault — ссылка стоит внутри подписи чекбокса и не должна ставить галочку */}
    <Dialog.Trigger
      className={styles.trigger}
      nativeButton={false}
      render={<span />}
      onClick={(e) => e.preventDefault()}
    >
      {trigger}
    </Dialog.Trigger>
    <Dialog.Portal>
      <Dialog.Backdrop className={styles.backdrop} />
      <Dialog.Popup className={styles.popup}>
        <div className={styles.header}>
          <Dialog.Title className={styles.title}>{title}</Dialog.Title>
          <Dialog.Close className={styles.close} aria-label="Закрыть">
            <X aria-hidden />
          </Dialog.Close>
        </div>
        <div className={styles.body}>
          <LegalProse>{children}</LegalProse>
        </div>
      </Dialog.Popup>
    </Dialog.Portal>
  </Dialog.Root>
);
